module.exports = __webpack_public_path__ + "static/img/tech.930409a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/features/tech.png
// module id = haTE
// module chunks = 6